import { render, staticRenderFns } from "./GrupoCompraCotacaoVisualizacaoAberta.vue?vue&type=template&id=7b90b1df&"
import script from "./GrupoCompraCotacaoVisualizacaoAberta.vue?vue&type=script&lang=js&"
export * from "./GrupoCompraCotacaoVisualizacaoAberta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports